import { configureCompat, createApp } from 'vue';

// Vue のルートを作る処理をここに集め、Vue 3 で変わったところの吸収と、@vue/compat を外すときに直す場所を 1 か所にする

configureCompat({ MODE: 2 });

const createVueApp = (options) => {
  const { router, store, propsData, data, ...component } = options;
  // Vue 3 のルートはオブジェクトの data を受け付けない
  if (data !== undefined) {
    component.data = typeof data === 'function' ? data : () => data;
  }
  const app = createApp(component, propsData);
  // DOM から取るテンプレートも SFC と同じく Vue 2 の空白の扱いにそろえる
  app.config.compilerOptions.whitespace = 'preserve';
  if (router) app.use(router);
  if (store) app.use(store);
  return app;
};

// el の中身をテンプレートにして、el の中に描画する（Vue 3 は el 自体のディレクティブを処理しない）
export const mountVueApp = (el, options) => {
  const app = createVueApp(options);
  const instance = app.mount(el);
  return { instance, unmount: () => app.unmount() };
};

// container は残して中身だけを描画結果に差し替える
export const mountVueAppInto = (container, options) => {
  const app = createVueApp(options);
  const instance = app.mount(container);
  return { instance, unmount: () => app.unmount() };
};
